module.exports = __webpack_public_path__ + "static/media/spoonerism-task (5).89d20a28.mp3";